import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, Scrollbar} from 'swiper/modules';
import '../../node_modules/swiper/swiper.scss';
import '../../node_modules/swiper/modules/navigation.scss';
import '../../node_modules/swiper/modules/pagination.scss';

// Initialize all Swiper instances on the page
document.querySelectorAll<HTMLElement>('.swiper').forEach((swiperContainer, _) => {
    new Swiper(swiperContainer, {
        modules: [Navigation, Pagination, Scrollbar, Autoplay],
        loop: true,
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true,
        },

        // You can use `querySelector` within the container to scope the controls
        pagination: {
            el: swiperContainer.querySelector('.swiper-pagination')! as HTMLElement,
            clickable: true,
        },
        navigation: {
            nextEl: swiperContainer.querySelector('.swiper-button-next')! as HTMLElement,
            prevEl: swiperContainer.querySelector('.swiper-button-prev')! as HTMLElement,
        }
    });
});
